import axios from "axios";
import { API_CONFIG } from "../config/api.config";
import skuTranslatorV0V1 from "./SkuTranslator";
import { engineStore } from "../components/engine/store/engineStore";

let dbRef = null;

const { SKU_DATA_DB_ENDPOINT, SKU_DATA_S3_ENDPOINT, S3_UPLOAD_ENDPOINT } =
  API_CONFIG;
/*
  1. Prod/Preprod - Engine we no need to worry about preprod param and data will be always from DB backed with Firebase
  2. Preprod - For Renderer, it should be always from DB backed with Firebase
  3. Prod - For Renderer, it should always get data from the S3

  Engine    ----> DB
  Renderer--|--- preprod ---> DB
            |
            |--- prod ------> S3
*/

// export const firebaseRef = firebase.initializeApp({
//   apiKey: "AIzaSyB8T2A-nchTzQ2Zj1iQgUzgMmHAmQNGRgQ",
//   authDomain: "engine-prod.firebaseapp.com",
//   databaseURL: "https://engine-prod-default-rtdb.firebaseio.com",
//   projectId: "engine-prod",
//   storageBucket: "engine-prod.appspot.com",
//   messagingSenderId: "31459171121",
//   appId: "1:31459171121:web:c2f0af85cb09d5b5476e10",
// });

// const dbRef = firebaseRef.database().ref();

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function getSKUData(skuId) {
  try {
    console.group("[SKUFirebase] - [getSKUData]");
    if (dbRef == null || dbRef === undefined) {
      const firebase = await import(
        "firebase" /* webpackChunkName: "firebase" */
      );
      console.log(firebase);
      const firebaseRef = firebase.default.initializeApp({
        apiKey: "AIzaSyB8T2A-nchTzQ2Zj1iQgUzgMmHAmQNGRgQ",
        authDomain: "engine-prod.firebaseapp.com",
        databaseURL: "https://engine-prod-default-rtdb.firebaseio.com",
        projectId: "engine-prod",
        storageBucket: "engine-prod.appspot.com",
        messagingSenderId: "31459171121",
        appId: "1:31459171121:web:c2f0af85cb09d5b5476e10",
      });
      dbRef = firebaseRef.database().ref();
    }

    const response = await dbRef.child("skudata").child(skuId).get();
    const v0Config = response.val();
    if (!v0Config) return null;
    const translatedConfig = await skuTranslatorV0V1(v0Config, skuId);
    console.log(response.val(), "--------getSKUData--------");
    console.groupEnd();
    return translatedConfig;
  } catch (error) {
    console.log("Calling again if client is offline", error);
    await sleep(2000);
    const data = await getSKUData(skuId);
    return data;
  }
}

export async function getSKUDataFromDb(context) {
  const { skuId, clientId } = context;
  try {
    const data = await fetch(
      `${SKU_DATA_DB_ENDPOINT}/v1/engine/${clientId}/${skuId}`
    )
      .then((res) => res.json())
      .then((finalRes) => finalRes);
    return data.config;
  } catch (error) {
    console.log("Error during fetch DB", error);
    return null;
  }
}

export async function getSKUDataFromS3(context) {
  const { skuId, clientId } = context;
  try {
    const fetchURL = `${SKU_DATA_S3_ENDPOINT}/skuConfigs/${clientId}/${skuId}.json`;
    const data = await fetch(fetchURL)
      .then((res) => res.json())
      .then((finalRes) => finalRes);
    return data;
  } catch (error) {
    console.log("Error during fetch S3", error);
    return null;
  }
}

export const uploadFileToS3 = async (
  file,
  skuId,
  clientId,
  category,
  action = "UPLOAD"
) => {
  try {
    const { name: fileName } = file;
    const updatedName = fileName.replace(/[^a-zA-Z0-9._]/g, "_");
    const updatedCategory = category.toUpperCase();

    const presignedRes = await axios.get(
      `${SKU_DATA_DB_ENDPOINT}/v1/engine/presigned-url?clientCode=${clientId}&clientSkuId=${skuId}&category=${updatedCategory}&fileName=${updatedName}&action=${action}`
    );
    console.log(
      "🚀 ~ file: SKUClient.js ~ line 117 ~ presignedRes",
      presignedRes
    );
    const presignedUrl = presignedRes.data.preSignedUrl.split("?")[0];
    console.log(
      "🚀 ~ file: SKUClient.js ~ line 119 ~ presignedUrl",
      presignedUrl
    );
    const fileUrl = `${S3_UPLOAD_ENDPOINT}${
      presignedUrl.split(".amazonaws.com")[1]
    }`;
    console.log("🚀 ~ file: SKUClient.js ~ line 121 ~ fileUrl", fileUrl);
    const uploadRes = await axios.put(presignedRes.data.preSignedUrl, file, {
      headers: {
        "Content-Type": file.type,
      },
    });
    console.log("🚀 ~ file: SKUClient.js ~ line 134 ~ uploadRes", uploadRes);

    engineStore().setNotifyMessage({
      showNotify: true,
      notifyMessage: "File uploaded successfully",
    });
    console.log("🚀 ~ file: SKUClient.js ~ line 143 ~ fileUrl", fileUrl);
    return fileUrl;
  } catch (err) {
    console.log("Error in File Upload: ", err);
    engineStore().setNotifyMessage({
      showNotify: true,
      notifyMessage: "Error in File Upload",
    });
    return "";
  }
};

export const saveSKUData = (config, skuId, clientId) => {
  try {
    axios.put(`${SKU_DATA_DB_ENDPOINT}/v1/engine/${clientId}/${skuId}`, config);
    engineStore().setNotifyMessage({
      showNotify: true,
      notifyMessage: "Data saved successfully",
    });
  } catch (error) {
    console.log("Error in Saving SKU config: ", error);
    engineStore().setNotifyMessage({
      showNotify: true,
      notifyMessage: `${error.code ?? null} Error in Saving SKU config`,
    });
    const configJson = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(config)
    )}`;
    const anchorEl = document.createElement("a");
    anchorEl.setAttribute("href", configJson);
    anchorEl.setAttribute(
      "download",
      `${skuId}_${Math.floor(Date.now() / 1000)}.json`
    );
    document.body.appendChild(anchorEl);
    anchorEl.click();
    anchorEl.remove();
  }
};
